import {
  typographyStyles,
  constants,
  mediaQueryStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;

const {
  BreakpointNames: { md, sm, xs },
} = constants.breakpoints;
const { heading2Obj, heading3Obj, heading4Obj, heading6Obj, textMObj } =
  typographyStyles;

const spacing = "0.5rem";
const grey = constants.colors.ui.neutral[500];
const greyExtraLight = constants.colors.ui.neutral[25];
const greyDark = constants.colors.ui.neutral[600];
const greyLight = constants.colors.ui.neutral[100];
const primaryColor = constants.colors.status.info[500];
const white = constants.colors.status.white[500];

export const assignmentEditorLayoutCss = {
  display: "flex",
  margin: "0 2.0rem",
  flexDirection: "column",
};

export const assignmentSectionCss = {
  [mediaQuery.downTo(md)]: {
    width: "940px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  maxWidth: "940px",
};

export const assignmentTitleCss = [
  {
    textAlign: "left",
    [mediaQuery.downTo(md)]: {
      width: "940px",
    },
    margin: "0 auto",
  },
  heading2Obj,
];

export const assignmentSubTitleCss = [
  {
    marginTop: "16px",
    marginBottom: "16px",
    [mediaQuery.upTo(md)]: {
      marginLeft: "48px",
      marginRight: "48px",
    },
  },
  textMObj,
];

export const baseDetailsRowCss = {
  display: "flex",
  flexFlow: "row wrap",
  gap: "32px",
};

export const inputsRowCss = {
  display: "flex",
  flexFlow: "row wrap",
  gap: 0,
  [mediaQuery.downTo(xs)]: {
    gap: "32px",
  },
  "> div": {
    flexGrow: 1,
    [mediaQuery.downTo(md)]: {
      maxWidth: "50%",
    },
  },
};

export const levelLockMenuCSS = {
  marginTop: "3px",
};

export const levelLockingLoadingWrapperCss = {
  width: "292px",
  height: "48px",
  marginTop: "22px",
};

export const navigationCSS = [
  {
    borderBottom: `1px ${greyLight} solid`,
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    height: "64px",
    marginBottom: "32px",
    padding: "1rem",
    [mediaQuery.downTo(sm)]: {
      marginBottom: "0px",
    },
  },
];

export const pageTitleCSS = [
  {
    lineHeight: 1.2,
    maxWidth: "940px",
    width: "100%",
    margin: "auto",
  },
  heading4Obj,
];

export const buttonRowCSS = {
  display: "flex",
  minHeight: "48px",
  justifyContent: "flex-end",
  alignItems: "center",
  ">*": {
    marginLeft: spacing,
  },
};

export const navButtonRowCSS = [
  {
    marginTop: "24px",
    [mediaQuery.downTo(sm)]: {
      position: "absolute",
      right: "2rem",
      marginTop: 0,
    },
  },
  buttonRowCSS,
];

export const cardCss = {
  height: "350px !important",
  boxSizing: "content-box",
  borderRadius: "5px",
};

export const gridLayoutCss = {
  listStyleType: "none",
  padding: 0,
  minWidth: "100%",
  display: "grid",
  gridAutoRows: "388px",
  gridGap: "30px",
  gridAutoFlow: "dense",

  gridTemplateColumns: "repeat(1, 1fr)",
  [mediaQuery.downTo(xs)]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [mediaQuery.downTo(md)]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
};

export const stepLayoutCss = {
  display: "grid",
  gridGap: "30px",
  gridAutoFlow: "dense",
  listStyleType: "none",
  padding: 0,
};

export const assignmentEditorLabelCss = [
  {
    color: greyDark,
    marginTop: spacing,
    fontWeight: "bold",
    lineHeight: 1.14,
    margin: "2rem 0 1rem",
  },
  heading6Obj,
];

export const assignmentTitleInputCSS = [
  {
    width: "100%",
    flex: "9999",
    display: "block",
  },
  {
    input: {
      ...heading3Obj,
      lineHeight: 1.33,
      width: "100%",
    },
  },
  {
    "div > div": {
      assignmentEditorLabelCss,
      marginTop: 0,
    },
  },
];

export const addIconCss = {
  height: "24px",
  width: "24px",
};

export const modalContentWrapperCss = (headerHeight) => ({
  "&&": {
    [mediaQuery.downTo(md)]: {
      marginTop: headerHeight,
    },
  },
});

export const discardChangesModalCss = {
  height: "auto",
};

export const levelLockHelperTextCSS = {
  margin: 0,
  padding: 0,
  span: {
    fontWeight: "bold",
  },
};

export const toastMessageSpacing = {
  [mediaQuery.downTo(sm)]: {
    marginTop: "35px",
    marginBottom: "35px",
  },
};

export const toastMessageSize = {
  [mediaQuery.downTo(sm)]: {
    margin: "7px auto",
    width: "90%",
  },
};
export const toastMessageCta = {
  backgroundColor: `${primaryColor}`,
  color: `${white}`,
  textDecorationLine: "underline",
};

export const selectAssigneesInfoText = {
  color: grey,
  padding: "2rem 0 3rem 0",
};

export const assigneeManagementButtonsCss = {
  display: "flex",
  flexFlow: "row nowrap",
  justifyContent: "flex-start",
  ">*": {
    marginRight: spacing,
  },
  "> div > button": {
    height: "100%",
  },
};

export const assignmentContainerCss = {
  alignItems: "center",
  backgroundColor: greyExtraLight,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: "2rem -2.0rem 0",
  padding: "-3.0rem 0 2rem",
};

export const disclaimerCss = [
  {
    color: greyDark,
  },
  heading6Obj,
];

export const assignmentStudentInstructionsCss = {
  marginBottom: "0",
};

export const contentLabelCss = [
  {
    color: greyDark,
    lineHeight: 1.14,
    fontWeight: "bold",
    marginRight: "2rem",
  },
  heading6Obj,
];
